import React from 'react'
import {
  Redirect,
  Route,
  Switch
} from 'react-router-dom'
import {CContainer, CFade} from '@coreui/react'
import {routes, allRoutes} from '../RoutesConfig'
import store from "../store";

const Content = (props) => {
  const userSession = store.getState()?.userSession;
  const routesToDisplay = userSession?.token ? routes : allRoutes;
  const redirectTo = userSession?.token ? "/dashboard" : "/login";

  return (
    <main className="c-main">
      <CContainer fluid>
        <Switch>
          {
            routesToDisplay.map((route, idx) => {
              return route.component && (
                <Route
                  key={idx}
                  path={route.path}
                  exact={route.exact}
                  name={route.name}
                  render={
                    props => (
                      <CFade>
                        <route.component {...props} userSession={userSession} />
                      </CFade>
                    )}/>
              )
            })}
          <Redirect from="/" to={redirectTo}/>
        </Switch>
      </CContainer>
    </main>
  )
}

export default React.memo(Content);
